import React from "react";
import * as model from "modules/insiders/model";
import * as formik from "components/generic/form/formik";

// TODO: validation is not working
export default ({ slots, loadMore }) => (
  <div className="f6">
    <formik.RadioList name="slot">
      {model
        .getInsiderAvailability(slots.data.results)
        .map(({ id, time }, i) => (
          <formik.RadioList.Item title={time} value={id.toString()} key={i} />
        ))}
      {slots.isFetching
        ? "Loading..."
        : slots.data.next && (
            <span
              className="pointer underline fw6 brand"
              onClick={() => loadMore(slots.data.next)}
            >
              Load more
            </span>
          )}
    </formik.RadioList>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/TimeSlots/View.js